import { render, staticRenderFns } from "./GameRank.vue?vue&type=template&id=3ab4cbab&scoped=true&"
import script from "./GameRank.vue?vue&type=script&lang=js&"
export * from "./GameRank.vue?vue&type=script&lang=js&"
import style0 from "./GameRank.vue?vue&type=style&index=0&id=3ab4cbab&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ab4cbab",
  null
  
)

export default component.exports